import React, {useState} from "react";

const ValueGenerationSection = ({volumeDaily, volumeWeekly, volumeMonthly, volumeQuarterly, volumeSemiAnnually, volumeAnnually}) => {
  const FEE_PERCENT = 5;
  const feeData = {
    "24h": {
      label: "24 Hours",
      total: parseFloat(volumeDaily * FEE_PERCENT / 100).toFixed(2),
      breakdown: {
        dao: parseFloat(volumeDaily * 0.02).toFixed(2),
        rewards: parseFloat(volumeDaily * 0.01).toFixed(2),
        burn: parseFloat(volumeDaily * 0.005).toFixed(2),
        staker: parseFloat(volumeDaily * 0.01).toFixed(2),
        liquidity: parseFloat(volumeDaily * 0.005).toFixed(2),
      }
    },
    "7d": {
      label: "7 Days",
      total: parseFloat(volumeWeekly * FEE_PERCENT / 100).toFixed(2),
      breakdown: {
        dao: parseFloat(volumeWeekly * 0.02).toFixed(2),
        rewards: parseFloat(volumeWeekly * 0.01).toFixed(2),
        burn: parseFloat(volumeWeekly * 0.005).toFixed(2),
        staker: parseFloat(volumeWeekly * 0.01).toFixed(2),
        liquidity: parseFloat(volumeWeekly * 0.005).toFixed(2),
      }
    },
    "30d": {
      label: "30 Days",
      total: parseFloat(volumeMonthly * FEE_PERCENT / 100).toFixed(2),
      breakdown: {
        dao: parseFloat(volumeMonthly * 0.02).toFixed(2),
        rewards: parseFloat(volumeMonthly * 0.01).toFixed(2),
        burn: parseFloat(volumeMonthly * 0.005).toFixed(2),
        staker: parseFloat(volumeMonthly * 0.01).toFixed(2),
        liquidity: parseFloat(volumeMonthly * 0.005).toFixed(2),
      }
    },
    "90d": {
      label: "90 Days",
      total: parseFloat(volumeQuarterly * FEE_PERCENT / 100).toFixed(2),
      breakdown: {
        dao: parseFloat(volumeQuarterly * 0.02).toFixed(2),
        rewards: parseFloat(volumeQuarterly * 0.01).toFixed(2),
        burn: parseFloat(volumeQuarterly * 0.005).toFixed(2),
        staker: parseFloat(volumeQuarterly * 0.01).toFixed(2),
        liquidity: parseFloat(volumeQuarterly * 0.005).toFixed(2),
      }
    },
    "180d": {
      label: "180 Days",
      total: parseFloat(volumeSemiAnnually * FEE_PERCENT / 100).toFixed(2),
      breakdown: {
        dao: parseFloat(volumeSemiAnnually * 0.02).toFixed(2),
        rewards: parseFloat(volumeSemiAnnually * 0.01).toFixed(2),
        burn: parseFloat(volumeSemiAnnually * 0.005).toFixed(2),
        staker: parseFloat(volumeSemiAnnually * 0.01).toFixed(2),
        liquidity: parseFloat(volumeSemiAnnually * 0.005).toFixed(2),
      }
    }, 
    "365d": { 
      label: "1 Year",
      total: (volumeAnnually * FEE_PERCENT / 100).toFixed(2),
      breakdown: {
        dao: (volumeAnnually * 0.02).toFixed(2),
        rewards: (volumeAnnually * 0.01).toFixed(2),
        burn: (volumeAnnually * 0.005).toFixed(2),
        staker: (volumeAnnually * 0.01).toFixed(2),
        liquidity: (volumeAnnually * 0.005).toFixed(2),
      }
    }
  };
  
  const [selected, setSelected] = useState("24h");
  const handleSelect = (period) => {
    setSelected(period);
  };
  const selectedData = feeData[selected];
  return (
    <div className="RewardsSec  tarnsaGold statsALL">
      <div className="PTGC-fee-allocation">
        <div className="topcards hoverboxes gredientBG mb-3" style={{border:'0px'}}>
        <div className=" row">
          {Object.entries(feeData).map(([key, card]) => (
            <div key={key} className='col-lg-4'  data-aos="fade-up"  data-aos-delay="600" data-aos-duration="400">
              <div
                key={key}
                className={`freesMulti ${selected === key ? "active" : ""}`}
                onClick={() => handleSelect(key)}
              >
                <div className="card-label fInter"><i className="fa-solid fa-calendar-days"></i> {card.label}</div>
                <div className="dollorVal f18 mt-0">
                  <span className="dollor">$</span>
                  <span className="val f18">{parseFloat(card.total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </div>
                <div className="card-subtext fInter">$ Fees Collected</div>
              </div>
            </div>
          ))}

        </div>
        </div>
        <div className="topcards pt-0">
        <div className="note" data-aos="fade-up"  data-aos-delay="700" data-aos-duration="400">
         <i className="fa-solid fa-circle-info"></i>  All values represent 5% of total PTGC trading volume for each time period
        </div>
        <div className="row">
          <div className='col-lg-4' data-aos="fade-up"  data-aos-delay="800" data-aos-duration="400">
            <div className="freesMulti">
              <div className="card-label fInter">DAO</div>
              <div className="dollorVal f28 mt-0 mb-0">
                <span className="dollor">$</span>
                <span className="val f28">{parseFloat(selectedData.breakdown.dao).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
              <div className="card-subtext fInter">2% allocated to DAO</div>
            </div>
          </div>

          <div className='col-lg-4' data-aos="fade-up"  data-aos-delay="900" data-aos-duration="400">
            <div className="freesMulti">
              <div className="card-label fInter">Rewards</div>
              <div className="dollorVal f28 mt-0 mb-0">
                <span className="dollor">$</span>
                <span className="val f28">{parseFloat(selectedData.breakdown.rewards).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
              <div className="card-subtext fInter">1% reflected to holders</div>
            </div>
          </div>

          <div className='col-lg-4' data-aos="fade-up"  data-aos-delay="1000" data-aos-duration="400">
            <div className="freesMulti">
              <div className="card-label fInter">Burn </div>
              <div className="dollorVal f28 mt-0 mb-0">
                <span className="dollor">$</span>
                <span className="val f28">{parseFloat(selectedData.breakdown.burn).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
              <div className="card-subtext fInter">0.5% of volume burned</div>
            </div>
          </div>
          <div className='col-lg-4' data-aos="fade-up"  data-aos-delay="1100" data-aos-duration="400">
            <div className="freesMulti">
              <div className="card-label fInter">Staking</div>
              <div className="dollorVal f28 mt-0 mb-0">
                <span className="dollor">$</span>
                <span className="val f28">{parseFloat(selectedData.breakdown.staker).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
              <div className="card-subtext fInter">1% reflected to stakers</div>
            </div>
          </div>

          <div className='col-lg-4' data-aos="fade-up"  data-aos-delay="1200" data-aos-duration="400">
            <div className="freesMulti">
              <div className="card-label fInter">Liquidity</div>
              <div className="dollorVal f28 mt-0 mb-0">
                <span className="dollor">$</span>
                <span className="val f28">{parseFloat(selectedData.breakdown.liquidity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
              <div className="card-subtext fInter">0.5% added to liquidity</div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default ValueGenerationSection;
